import { render, staticRenderFns } from "./SearchTerms.vue?vue&type=template&id=3ea35498&scoped=true&"
import script from "./SearchTerms.vue?vue&type=script&lang=js&"
export * from "./SearchTerms.vue?vue&type=script&lang=js&"
import style0 from "./SearchTerms.vue?vue&type=style&index=0&id=3ea35498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea35498",
  null
  
)

export default component.exports